export const SNAP_CONTAINER = 'snap-container';
